/* Defy The Norm / navigation enhancements for the Emerge header and mobile drawer. */

/* ---------- Desktop mega menus: add a heading column (eyebrow, title, shop-all link) ---------- */
function dtnMegaHeads() {
  let changed = false;
  document.querySelectorAll('.x-menu--level-1--link[data-megamenu="true"]').forEach((li) => {
    const a = li.querySelector(':scope > a');
    const panel = li.querySelector(':scope > .x-menu--level-2--container');
    if (!a || !panel || panel.querySelector(':scope > .dtn-mega__col')) return;
    const title = (li.querySelector('.x-menu--level-1--text')?.textContent || a.textContent || '').trim();
    const href = a.getAttribute('href') || '#';
    const isShop = /\/collections\//.test(href);

    const col = document.createElement('div');
    col.className = 'dtn-mega__col';
    const head = document.createElement('div');
    head.className = 'dtn-mega__head';
    const eyebrow = document.createElement('p');
    eyebrow.className = 'dtn-mega__eyebrow';
    eyebrow.textContent = isShop ? 'Shop' : 'Explore';
    const h = document.createElement('p');
    h.className = 'dtn-mega__title';
    h.textContent = title;
    const all = document.createElement('a');
    all.className = 'dtn-mega__all';
    all.href = href;
    all.textContent = (isShop ? 'Shop all ' : 'View ') + title.toLowerCase();
    head.append(eyebrow, h, all);
    col.appendChild(head);

    const wrap = panel.querySelector(':scope > .x-menu--level-2--wrapper');
    panel.insertBefore(col, panel.firstChild);
    if (wrap) col.appendChild(wrap);
    li.setAttribute('data-dtn-mega', wrap ? 'links' : 'blocks');
    changed = true;
  });
  if (changed) dtnRemeasure();
}

/* Emerge animates dropdowns to a measured height, so measure again after changing their contents */
function dtnRemeasure() {
  customElements.whenDefined('x-menu-element').then(() => {
    document.querySelectorAll('x-menu-element').forEach((m) => {
      if (typeof m.setNaturalHeights === 'function' && !m.open_menu) m.setNaturalHeights();
    });
  });
}

/* ---------- Desktop dropdowns: make open and close reliable ----------
   Emerge's menu can leave a panel half open when the cursor moves fast:
   - the height it animates to was measured once on page load, before images and fonts settled
   - a close that lands in the same frame as an open was undone by the open's delayed step
   - any hover transition inside the panel ended the close early
   These overrides measure each panel when it opens, ignore stale steps, and a watchdog
   closes anything left open once the cursor and focus have left the menu. */
function dtnPanelHeight(panel) {
  // Same measurement Emerge uses (height auto), done at open time so it reflects loaded images and fonts
  const prev = panel.style.getPropertyValue('--height');
  panel.style.setProperty('--height', 'auto');
  const h = panel.offsetHeight;
  panel.style.setProperty('--height', prev || '0px');
  return h;
}
function dtnForceClose(menu) {
  (menu.menus || menu.querySelectorAll('.x-menu--level-2--container')).forEach((p) => {
    if (p._dtnEnd) { p.removeEventListener('transitionend', p._dtnEnd); p._dtnEnd = null; }
    clearTimeout(p._dtnT);
    p.style.setProperty('--height', '0px');
    p.setAttribute('aria-hidden', 'true');
    p.previousElementSibling?.setAttribute('aria-expanded', 'false');
  });
  if (typeof menu.resetTimer === 'function') menu.resetTimer();
  menu.open_menu = null;
}
function dtnPatchMenu() {
  if (!window.customElements) return;
  customElements.whenDefined('x-menu-element').then(() => {
    const Emerge = customElements.get('x-menu-element');
    const base = Object.getPrototypeOf(Emerge.prototype);
    if (!base || base._dtnPatched || typeof base.openMenu !== 'function') return;
    base._dtnPatched = true;

    base.openMenu = function (link, swap = false) {
      const panel = link && link.nextElementSibling;
      if (!panel) return;
      if (panel._dtnEnd) { panel.removeEventListener('transitionend', panel._dtnEnd); panel._dtnEnd = null; }
      clearTimeout(panel._dtnT);
      if (swap && this.open_menu && this.open_menu !== panel) {
        panel.style.setProperty('--height', getComputedStyle(this.open_menu).height);
        this.closeMenu(true);
      } else if (this.open_menu && this.open_menu !== panel) {
        this.closeMenu(true);
        panel.style.setProperty('--height', '0px');
      } else if (this.open_menu !== panel) {
        panel.style.setProperty('--height', '0px');
      }
      // Close strays from earlier interrupted opens
      (this.menus || []).forEach((p) => { if (p !== panel && p.getAttribute('aria-hidden') === 'false') { p.style.setProperty('--height', '0px'); p.setAttribute('aria-hidden', 'true'); p.previousElementSibling?.setAttribute('aria-expanded', 'false'); } });
      this.open_menu = panel;
      link.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.style.setProperty('--natural-height', dtnPanelHeight(panel) + 'px');
      requestAnimationFrame(() => {
        if (this.open_menu === panel && link.getAttribute('aria-expanded') === 'true') panel.style.setProperty('--height', 'var(--natural-height)');
      });
      // Content that grows after opening (images, fonts) grows the panel with it
      if (!panel._dtnRO && window.ResizeObserver) {
        panel._dtnRO = new ResizeObserver(() => {
          if (panel.getAttribute('aria-hidden') === 'false' && panel.previousElementSibling?.getAttribute('aria-expanded') === 'true') {
            panel.style.setProperty('--natural-height', dtnPanelHeight(panel) + 'px');
          }
        });
        [...panel.children].forEach((c) => panel._dtnRO.observe(c));
      }
    };

    base.closeMenu = function (force) {
      const panel = this.open_menu;
      if (!panel) return;
      panel.previousElementSibling?.setAttribute('aria-expanded', 'false');
      panel.style.setProperty('--height', '0px');
      if (typeof panel.off === 'function') panel.off('transitionend');
      if (panel._dtnEnd) { panel.removeEventListener('transitionend', panel._dtnEnd); panel._dtnEnd = null; }
      clearTimeout(panel._dtnT);
      const finish = () => {
        if (panel._dtnEnd) { panel.removeEventListener('transitionend', panel._dtnEnd); panel._dtnEnd = null; }
        clearTimeout(panel._dtnT);
        if (panel.previousElementSibling?.getAttribute('aria-expanded') === 'true') return; // reopened meanwhile
        if (typeof this.findAndResetTransition === 'function') this.findAndResetTransition(panel);
        panel.setAttribute('aria-hidden', 'true');
        if (this.open_menu === panel) this.open_menu = null;
      };
      if (force) { finish(); return; }
      // Only the panel's own transition counts, never a hover transition inside it
      panel._dtnEnd = (e) => { if (e.target === panel) finish(); };
      panel.addEventListener('transitionend', panel._dtnEnd);
      panel._dtnT = setTimeout(finish, 600);
    };

    // Watchdog: once the cursor and focus are out of the menu, nothing may stay open
    document.querySelectorAll('x-menu-element').forEach((menu) => {
      if (menu._dtnWatch) return;
      menu._dtnWatch = true;
      const check = () => {
        if (menu.matches(':hover') || menu.contains(document.activeElement)) return;
        const open = [...(menu.menus || [])].some((p) => p.getAttribute('aria-hidden') === 'false' || p.previousElementSibling?.getAttribute('aria-expanded') === 'true');
        if (open) { if (menu.open_menu) menu.closeMenu(); setTimeout(() => { if (!menu.matches(':hover')) dtnForceClose(menu); }, 650); }
      };
      menu.addEventListener('mouseleave', () => setTimeout(check, 150));
      let ticking = false;
      window.addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; check(); }); }, { passive: true });
      document.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse' || menu._dtnPM) return;
        menu._dtnPM = setTimeout(() => { menu._dtnPM = null; check(); }, 400);
      }, { passive: true });
    });
  });
}

/* ---------- Mobile drawer: shop tiles, account, search, promo note and social icons ---------- */
function dtnMobileExtras() {
  const tpl = document.getElementById('dtn-mnav-tpl');
  const nav = document.querySelector('.drawer--side .mobile-nav') || document.querySelector('.mobile-nav');
  if (!tpl || !nav) return;
  nav.querySelectorAll(':scope > .dtn-mnav').forEach((el) => el.remove());
  const frag = tpl.content.cloneNode(true);
  const footer = nav.querySelector(':scope > .mobile-nav--footer');
  if (footer) nav.insertBefore(frag, footer); else nav.appendChild(frag);
}

function dtnNavInit() {
  dtnPatchMenu();
  dtnMegaHeads();
  dtnMobileExtras();
}

dtnNavInit();
window.addEventListener('load', () => { dtnMegaHeads(); dtnRemeasure(); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(dtnRemeasure);
document.addEventListener('shopify:section:load', () => setTimeout(dtnNavInit, 50));
